// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__3R4Wz","footer":"ModalInfo_footer__uKl75"};